'use client';

import api from './api';
import { readBrowserSession } from './auth-storage';

let linking: Promise<void> | undefined;
export function clearAcquisitionIdentity() {
  void window.pteAcquisitionReset?.();
}

export async function prepareAcquisition() {
  if (typeof window === 'undefined') return;
  try { await window.pteAcquisitionReady?.(); } catch { /* Authentication remains available. */ }
}

export function linkAcquisitionVisits(): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve();
  if (linking) return linking;
  linking = (async () => {
    const loginId = readBrowserSession()?.loginId;
    if (!loginId) return;
    await prepareAcquisition();
    if (readBrowserSession()?.loginId !== loginId) return;
    try {
      const claim = await api.post<{ success: boolean; data?: { linked: boolean; reset?: boolean } }>('/Acquisition/link-browser', undefined,
        { timeout: 5000 });
      if (readBrowserSession()?.loginId !== loginId) return;
      if (!claim.data.success || !claim.data.data?.linked) return;
      if (claim.data.data.reset) window.pteAcquisitionClear?.();
    } catch { return; } // A later authenticated visit retries the durable browser claim.
    const deadline = Date.now() + 5000;
    for (const token of window.pteAcquisitionPending?.() ?? []) {
      if (readBrowserSession()?.loginId !== loginId || Date.now() >= deadline) break;
      try {
        const { data } = await api.post<{ success: boolean; data?: { linked: boolean } }>(
          '/Acquisition/link', undefined,
          { headers: { 'X-Acquisition-Token': token },
            timeout: Math.max(1, deadline - Date.now()) });
        if (readBrowserSession()?.loginId !== loginId) break;
        if (data.success && data.data?.linked) window.pteAcquisitionLinked?.(token);
      } catch (error) {
        if (readBrowserSession()?.loginId !== loginId) break;
        const status = (error as { response?: { status?: number } }).response?.status;
        if (status === 400 || status === 409) window.pteAcquisitionLinked?.(token);
        else break; // Keep transient failures for the next same-tab retry.
      }
    }
  })().finally(() => { linking = undefined; });
  return linking;
}
